import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/linked-to/edge-gateways")({
  staticData: {
    title: "linkedTo.edgeGateway.title",
  },
});
